import canUseMedia from './canUseMedia'

export default function isLargeTablet() {
  return canUseMedia && window.matchMedia('(min-width: 1024px)').matches
}
